/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs */

const en_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you’re prepared, focus finds its flow.`)
};

const ar_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عندما تكون مستعدًا، يجد التركيز انسيابه الطبيعي.`)
};

const de_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du bereit bist, findet der Fokus seinen Fluss.`)
};

const es_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando estás preparado, el enfoque encuentra su cauce.`)
};

const fr_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsque vous êtes prêt, la concentration trouve son propre cours.`)
};

const it_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando sei pronto, la concentrazione trova il suo flusso.`)
};

const ja_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備が整えば、集中は自ずと流れを見つけ出します。`)
};

const ko_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`준비가 되었을 때, 집중은 자연스러운 흐름을 찾습니다.`)
};

const pt_br_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você está preparado, o foco encontra seu fluxo.`)
};

const ru_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда вы готовы, концентрация обретает свой поток.`)
};

const th_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมื่อคุณพร้อม สมาธิจะค้นพบกระแสการไหลของมันเอง`)
};

const tr_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazır olduğunda, odak kendi akışını bulur.`)
};

const zh_cn_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注当下，静待时机，一切自会水到渠成。`)
};

const zh_tw_daily_paywall_exclusive_tree_water_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默默累積專注，待時機成熟，美好自會水到渠成。`)
};

/**
* | output |
* | --- |
* | "When you’re prepared, focus finds its flow." |
*
* @param {Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_exclusive_tree_water_subtitle = /** @type {((inputs?: Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Exclusive_Tree_Water_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "ar") return ar_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "de") return de_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "es") return es_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "fr") return fr_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "it") return it_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "ja") return ja_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "ko") return ko_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "ru") return ru_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "th") return th_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "tr") return tr_daily_paywall_exclusive_tree_water_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_exclusive_tree_water_subtitle(inputs)
	return zh_tw_daily_paywall_exclusive_tree_water_subtitle(inputs)
});